import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class PlaylistTask extends AbstractRequestTask {
  constructor(service = "", user, params, headers) {
    super();
    this._config = getAppConfig();
    this._service = service;
    this.method = params.method;
    this._params = {
      ...params,
    };
    this._headers = headers;

    this.cm_access_token = this._headers && this._headers.cm_access_token ? this._headers.cm_access_token : null;
    if(this._headers && this._headers.cm_access_token) {
      delete this._headers.cm_access_token;
    }

    if(!this.cm_access_token && params.cm_access_token) {
      this.cm_access_token = params.cm_access_token;
    }
  }

  getMethod() {
    return "GET";
  }

  getEncType() {
    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    const api =
      this._service === "level"
        ? "cms"
        : this._service === "ribbons"
        ? "cms"
        : "user";
    return `${this._config.end_point_music}/middleware/${api}/${this._service}`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    delete params.user_id;
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = this._service === "level" ? "2.0.0" : "1.0.0";
    if(this.cm_access_token) {
      params.cm_access_token = this.cm_access_token;
    }

    return { ...this._params, ...params };
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default PlaylistTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/PlaylistTask.js